import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAccountBalance,
  fetchPaginatedTransactions,
  getStripeRenewal,
} from "./transactionAPI";

export const getBalance = createAsyncThunk(
  "user/getBalance",
  async (thunkAPI) => {
    try {
      const data = await fetchAccountBalance();
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getPaginatedTransaction = createAsyncThunk(
  "user/allTransactions",
  async ({ page, limit }, thunkAPI) => {
    try {
      const data = await fetchPaginatedTransactions(page, limit);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getRenewals = createAsyncThunk(
  "stripe/renewal",
  async (thunkAPI) => {
    try {
      const response = await getStripeRenewal();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

const transactionSlice = createSlice({
  name: "transactions",
  initialState: {
    transactionsData: [],
    payments: [],
    transactions: [],
    balance: null,
    renewalDate: null,
    error: false,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaginatedTransaction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaginatedTransaction.fulfilled, (state, action) => {
        state.loading = false;
        state.transactionsData = action.payload;
      })
      .addCase(getPaginatedTransaction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getBalance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.balance = action.payload;
      })
      .addCase(getBalance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getRenewals.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getRenewals.fulfilled, (state, action) => {
        state.loading = false;
        state.renewalDate = action.payload.data;
      })
      .addCase(getRenewals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default transactionSlice.reducer;
